import { hasPetExecutions } from './missionState.js';
export function hasPetContinuity(catalog) {
    return hasPetExecutions(catalog) && catalog?.capabilities.missions?.executions?.continuity?.supported === true && catalog.capabilities.missions.executions.continuity.available === true;
}
export function hasPetDecisionContinuation(catalog) {
    return hasPetContinuity(catalog) && catalog?.capabilities.missions?.executions?.continuity?.decisionContinuation.available === true;
}
export const continuityMoney = (micros) => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 6 }).format(micros / 1000000);
export const localTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
/** Editing a local wall time is explicit. Reject daylight-saving gaps instead of silently shifting it. */
export function localInstant(value) {
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value))
        return null;
    const parsed = new Date(value);
    if (!Number.isFinite(parsed.getTime()))
        return null;
    const pad = (part) => String(part).padStart(2, '0');
    const roundTrip = `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
    return roundTrip === value ? parsed.toISOString() : null;
}
export const localClockText = (minute) => `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;
export function localInput(value) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime()))
        return '';
    const pad = (part) => String(part).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
export function scheduleLabel(schedule) {
    return schedule.rule.kind === 'once' ? 'One follow-up' : schedule.rule.kind === 'wall-clock' ? `Recurring · ${schedule.rule.timeZone}` : 'Adaptive check window';
}
export const wakeReasons = {
    'work-window': 'Waiting for your work window', capacity: 'Waiting for service capacity', connection: 'Connection needed', device: 'Waiting for your device', paused: 'Responsibility paused', 'wake-limit': 'Follow-up limit reached', 'cost-limit': 'Automatic budget limit reached', 'prior-outcome': 'An earlier outcome is still unresolved', capability: 'Required capability unavailable',
};
//# sourceMappingURL=continuityModel.js.map